import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const reviewsData = [
  {
    name: "Jatin Aggarwal",
    review: "Dr. Manish Khattar is one of the best, if not THE best, urologists in lucknow, or rather the entirety of UP. His patience and dedication are commendable to say the least. His way of making scary procedures look so simple is out of this world. Would highly recommend for any sort of urology consult. :)",
  },
  {
    name: "konkimalla abhilash",
    review: "Very kind and soft spoken doctor! Takes time to explain the problem and solution in detail. Highly recommended!",
  },
  {
    name: "Raman Singh",
    review: "☆☆☆☆☆ ",
  },
 
  
];

const Reviews = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div style={{ width: "80%", margin: "0 auto", padding: "50px 0" }}>
      <h2 style={{ textAlign: "center" }}>Customer Reviews</h2>
      <Slider {...sliderSettings}>
        {reviewsData.map((review, index) => (
          <div key={index} style={{ textAlign: "center", padding: "20px" }}>
            <div
              style={{
                width: "100px",
                height: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor: "#f4f4f4",
                color: "#555",
                fontWeight: "bold",
                fontSize: "18px",
                margin: "0 auto 10px",
              }}
            >
              GOOGLE
            </div>
            <h3>{review.name}</h3>
            <p style={{ fontStyle: "italic", color: "#555" }}>{`"${review.review}"`}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Reviews;
